<div class="img-fluid curve">
  <ng-content id="content"></ng-content>
</div>
